module.exports = __webpack_public_path__ + "img/cosmetic_hat.03fde83b.svg";